/**
 * Created by JackCui on 2020/10/14
 */

export const popoverStatus = {
  status: {
    showFlag: false
  },
  show () {
    this.status.showFlag = true
  },
  hide () {
    this.status.showFlag = false
  }
}
